module.exports = __webpack_public_path__ + "r-v3/img/translation_ES.34de94ff.png";